import { Component, OnInit } from '@angular/core';
import { TrnxCommonTs } from "src/app/shared/common/trnxCommonTs";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {CommonService} from '../../shared/services/common.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {LocalStorageSettingsService} from '../../shared/services/local-storage-settings.service';
import {UserRoutingModule} from 'src/app/user/user-routing/user-routing.module';
import { ReportlinksserviceService } from 'src/app/user/reportlinks/reportlinksservice.service';
import {AsignUserRoleService} from '../../shared/services/asign-user-role.service';
import {MigrationConfigComponentServices} from 'src/app/shared/services/Migrationconfiguration';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { MigrationConfigpopupComponent } from 'src/app/user/migration-config/migration-configpopup/migration-configpopup.component';
import { firstValueFrom } from 'rxjs';
import { constants } from "src/app/shared/common/contants";

@Component({
    selector: 'app-migration-config',
    templateUrl: './migration-config.component.html',
    styleUrls: ['./migration-config.component.scss'],
    standalone: false
})
export class MigrationConfigComponent implements OnInit {

  columnDefs;
  buttonIdList;
  gridAPI;
  gridColumnAPI;
  lastPage
  currentPage
  nextPage
  nextPagePlusOne
  totalPages;
  pageSize;
  getData;
  rowSelection
  defaultColDef
  paginationPageSize
  paginationNumberFormatter
  rowClassRules
  retrieveObject
  overlayNoRowsTemplate
  
  backgroundColorButton
  value;



  backgroundColorScreen = '';
  isdisable: boolean = false;
  components: any;
  



    constructor(
      private dialog: MatDialog, private commonService: CommonService, private localStorage: LocalStorageSettingsService,private asignUserRoleService:AsignUserRoleService,private trnxCommonTs: TrnxCommonTs,private migrationconfigservices: MigrationConfigComponentServices,
      private snackBar:MatSnackBar,private spinner:NgxUiLoaderService,private linkservice: ReportlinksserviceService,private userRoutingModule: UserRoutingModule,private reportLinkService:ReportlinksserviceService,private constants: constants
    ) {
      
     //if no rows , this message will display
    this.overlayNoRowsTemplate = this.constants.Norows;
    }

   ngOnInit() {

    let screenPath = this.userRoutingModule.print(this.constructor.name);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorage.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });

     // if the record has status==no , row color will change
    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };



    this.columnDefs = [
      {
        headerName: "Action",
        filter: false,
        cellRenderer: "buttonRenderer",
        cellRendererParams: {
          values:this.buttonIdList,
          edit: this.editIcon.bind(this),
          delete: this.deleteIcon.bind(this)
        },
        pinned: 'left',
        lockPinned: true,
        width: 170
      },
      {
        headerName: 'Run Id',
        headerTooltip: 'Run Id',
        tooltipValueGetter: (params) =>
          'migrationId : ' + params.value,
        field: 'migrationId',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'GlobalExtraction Duration',
        headerTooltip: 'GlobalExtraction Duration',
        tooltipValueGetter: (params) =>
          'GlobalExtraction Duration : ' + params.value,
        field: 'globalextractionduration',
        filter: 'agTextColumnFilter',
        width: 180,
      },

      {
        headerName: 'Extraction Duration',
        headerTooltip: 'Extraction Duration',
        tooltipValueGetter: (params) =>
          'extractionDuration : ' + params.value,
        field: 'extractionDuration',
        filter: 'agTextColumnFilter',
        width: 180,
      },

      {
        headerName: 'Transformation Duration',
        headerTooltip: 'Transformation Duration',
        tooltipValueGetter: (params) =>
          'transformationDuration : ' + params.value,
        field: 'transformationDuration',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Load Duration',
        headerTooltip: 'Load Duration',
        tooltipValueGetter: (params) =>
          'loadDuration : ' + params.value,
        field: 'loadDuration',
        filter: 'agTextColumnFilter',
        width: 180,
      },

      {
        headerName: 'Validation Duration',
        headerTooltip: 'Validation Duration',
        tooltipValueGetter: (params) =>
          'validationDuration : ' + params.value,
        field: 'validationDuration',
        filter: 'agTextColumnFilter',
        width: 180,
      },

      

    ];



    this.columnDefs.push({
      headerName: 'Status',
      headerTooltip: 'Status',
      tooltipValueGetter: (params) => 'Status : ' + params.value,
      field: 'status',
      filter: 'agTextColumnFilter',
      width: 150,
      cellStyle: function (params) {
        if (params.value == 'Yes') {
          return { color: 'green' };
        } else {
          return { color: 'red' };
        }
      }
    });

    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true,
    };

    //Initializing the ActionButton
    this.components = { buttonRenderer: Actionbutton}

    this.backgroundColorScreen = this.localStorage.getSettings("ColorD");

    this.backgroundColorButton = this.localStorage.getSettings("ColorA");

    this.retrieve();


    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };
  }


  async editIcon(e) {

    if (e.rowData.status == 'No' || e.rowData.status == null) {
      this.snackBar.open("Record Already Deleted", "OK", { duration: 5000 });
      return
    }

    console.log(e);
    console.log(e.rowData);
  
    let dialogRef = this.dialog.open(MigrationConfigpopupComponent, {
      maxWidth: '100vw',
      height: "90%",
      width: "55%",
      data: { "rowData": e.rowData , isEdit: true},
      disableClose: true
    });
  
    const result = await dialogRef.afterClosed().toPromise(); // Convert to Promise
    console.log(result);
    this.retrieve();
      
      if (result) {
        this.onBtFirst();
         // Await works now
      }
    
  }
  


  async deleteIcon(e) {

    if (e.rowData.status == 'No' || e.rowData.status == null) {
      this.snackBar.open("Record Already Deleted", "OK", { duration: 5000 });
      return
    }
    console.log("------------------");
    console.log(e.rowData);
    console.log("dnsId: ",e.rowData.dnsId);
    if (confirm("Are you sure you want to delete the Configuration?")== true) {
      this.spinner.start();
  
    try {
      const res: any = await firstValueFrom(this.migrationconfigservices.DeleteFromMigrationConfigComponentinfoData(e.rowData));
      console.log("Response:", res);
  
      if (res.data === "Successfully record is deleted") {
        console.log("Delete Successful:", res);
        this.retrieve();
        this.snackBar.open("Successfully record is deleted", "OK", { duration: 5000 });
      } else {
        console.log("Delete Failed:", res);
        this.snackBar.open(res?.statusMessage || "Deletion Failed", "OK", { duration: 5000 });
      }
    } catch (error) {
      console.error("Error during deletion:", error);
      this.snackBar.open("An error occurred while deleting the record", "OK", { duration: 5000 });
    } finally {
      this.spinner.stop();
    }
  }
    
  }

  async openSaveForm(type) {
    console.log(type);
  
    let dialogRef = this.dialog.open(MigrationConfigpopupComponent, {
      maxWidth: '100vw',
      height: "90%",
      width: "55%",
      disableClose: true,
      data: { isEdit: false }
    });
  
    const result = await dialogRef.afterClosed().toPromise(); // Convert to Promise
    console.log(result);

    this.retrieve();
  
    if (result) {
      this.onBtFirst();
    }
  }
  
    

    onPaginationChangedReturn() {
      if (this.gridAPI) {
        this.lastPage = this.gridAPI.paginationIsLastPageFound();
        this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;
        this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;
        this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;
        this.totalPages = this.gridAPI.paginationGetTotalPages();
      }
    }

      //excel export function
  onBtExport() {

    this.gridAPI.exportDataAsCsv();

  }

  //pagination code
  onPaginationChanged() {

    if (this.gridAPI) {

      this.lastPage = this.gridAPI.paginationIsLastPageFound();

      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;

      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;

      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;

      this.totalPages = this.gridAPI.paginationGetTotalPages();

    }

  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {

    this.gridAPI.paginationGoToPage(searchValue - 1);

  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {

    var value = this.pageSize;

    this.gridAPI.setGridOption('paginationPageSize', Number(value));

  }

  // below function is for going to next page
  async onBtNext() {

  

    this.gridAPI.paginationGoToNextPage();

  }

  // below function for going to previous page
  async onBtPrevious() {

    this.gridAPI.paginationGoToPreviousPage();

  }

  // below function for going to first page
  onBtFirst() {

    this.gridAPI.paginationGoToFirstPage();

  }

  // below function for going to last page
  onBtLast() {

    this.gridAPI.paginationGoToLastPage();

  }

  //pagination code ends

  // below function is to load the ag grid
  async onGridReady(params) {
    this.gridAPI = params.api;
    this.getData = [];
    this.gridColumnAPI = params.columnApi;

   // this.retrieveAssignUsersRoleByDnsId();
    //this.retrieveLogedInUser();



  }

  

  async retrieve() {
    this.spinner.start();
    console.log("calling...");
  
    try {
      const res: any = await firstValueFrom(this.migrationconfigservices.retreiveMigrationConfigComponentinfoData());
      console.log(res);
      this.gridAPI.setGridOption('rowData', res);
    } catch (error) {
      console.error(error);
      this.snackBar.open("Error occurred while fetching data", "OK", { duration: 5000 });
    } finally {
      this.spinner.stop();
    }
  }
  
 













}
